import { motion } from "framer-motion";

export function StorySubmissionForm() {
  return (
    <section id="submit-story" className="py-8 px-4 md:px-8 lg:px-16 max-w-7xl mx-auto z-50">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="lg:p-10"
      >
        <h2 className="text-3xl md:text-4xl font-bold text-black dark:text-white mb-6">
          By Sharing Your <span className="text-[#00C2CB]">Story..</span>
        </h2>
        <p className="text-gray-850 dark:text-gray-300 mb-8">
          You're helping others, your story could inspire healthcare 
          providers and patients alike to embrace innovative approaches to healthcare.
        </p>
        
        {/* Embedded Notion Form */}
        <iframe width="100%" height="1200px" className="rounded-xl" scrolling="yes" frameBorder="no" src="https://wave-seer-9d4.notion.site/ebd//2c2b1ec9cdab8083a930e21a444bc2fe"></iframe>
      </motion.div>
    </section>
  );
}